{
    "name": "craig.ui",
    "version": "1.0.15",
    "scripts": {
        "start": "cross-env NODE_OPTIONS=--max-old-space-size=4096 ng serve",
        "local": "cross-env NODE_OPTIONS=--max-old-space-size=4096 ng serve --configuration local",
        "build": "cross-env NODE_OPTIONS=--max-old-space-size=4096 ng build",
        "test": "cross-env NODE_OPTIONS=--max-old-space-size=4096 ng test",
        "test:feedback": "ng test --include='**/response-feedback/*.spec.ts' --watch=false --browsers=ChromeHeadless",
        "test:active": "ng test --include='**/active-conversation/**/*.spec.ts' --watch=false --browsers=ChromeHeadless",
        "prod-serve": "cross-env NODE_OPTIONS=--max-old-space-size=4096 ng serve --configuration production",
        "prod-build": "cross-env NODE_OPTIONS=--max-old-space-size=4096 ng build --configuration production",
        "lint": "ng lint",
        "prettier": "prettier --write \"**/*.{js,ts,css,less,html,json,md}\"",
        "clean-install": "rm -rf node_modules && rm -f package-lock.json && npm cache clean -f && npm i --package-lock-only && npm i",
        "prepare-husky": "husky install && husky add .husky/pre-commit \"npx lint-staged\""
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "18.2.13",
        "@angular/common": "18.2.13",
        "@angular/compiler": "18.2.13",
        "@angular/core": "18.2.13",
        "@angular/forms": "18.2.13",
        "@angular/platform-browser": "18.2.13",
        "@angular/platform-browser-dynamic": "18.2.13",
        "@angular/router": "18.2.13",
        "@ctrl/tinycolor": "4.1.0",
        "@epd/pattern-library": "0.1.81-alpha",
        "@microsoft/fetch-event-source": "^2.0.1",
        "jwt-decode": "4.0.0",
        "marked": "12.0.2",
        "ngx-markdown": "18.1.0",
        "rxjs": "7.8.1",
        "tslib": "2.8.1",
        "zone.js": "0.14.10"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "18.2.14",
        "@angular-eslint/builder": "18.4.3",
        "@angular-eslint/eslint-plugin": "18.4.3",
        "@angular-eslint/eslint-plugin-template": "18.4.3",
        "@angular-eslint/schematics": "18.4.3",
        "@angular-eslint/template-parser": "18.4.3",
        "@angular/cli": "18.2.14",
        "@angular/compiler-cli": "18.2.13",
        "@stylistic/eslint-plugin": "3.0.1",
        "@types/jasmine": "5.1.5",
        "@typescript-eslint/eslint-plugin": "8.23.0",
        "@typescript-eslint/parser": "8.23.0",
        "cross-env": "7.0.3",
        "eslint": "8.57.0",
        "eslint-plugin-custom-rules": "file:eslint-plugin-custom-rules",
        "eslint-plugin-deprecation": "3.0.0",
        "eslint-plugin-import": "2.31.0",
        "eslint-plugin-prefer-arrow": "1.2.3",
        "eslint-plugin-rxjs": "5.0.3",
        "husky": "8.0.3",
        "jasmine-core": "5.5.0",
        "karma": "6.4.4",
        "karma-chrome-launcher": "3.2.0",
        "karma-coverage": "2.2.1",
        "karma-jasmine": "5.1.0",
        "karma-jasmine-html-reporter": "2.1.0",
        "lint-staged": "15.4.3",
        "prettier": "3.4.2",
        "typescript": "5.5.4"
    }
}
